import React from 'react';
import Devices from '../../../views/corp/devices/Devices';

const devicesRoutes = [
  {
    path: '/corp/devices',
    element: <Devices />
  }
];

export default devicesRoutes;
